import { useIsPeriodicReview } from '@/features/periodic-review/context';
import { useProfileNationalClientIdentifier, useProfileNationalClientIdentifierMutation } from '@/hooks/queries/use-profile-national-client-identifier';
import { useProfilePeriodicReviewNationalClientIdentifier, useProfilePeriodicReviewNationalClientIdentifierMutation } from '@/hooks/queries/use-profile-periodic-review';

// These work on the draft inside a periodic review and on the live record everywhere else

export const useNationalClientIdentifier = () => {
  const isPeriodicReview = useIsPeriodicReview();
  const liveQuery = useProfileNationalClientIdentifier(!isPeriodicReview);
  const draftQuery = useProfilePeriodicReviewNationalClientIdentifier(isPeriodicReview);

  return isPeriodicReview ? draftQuery : liveQuery;
};

export const useNationalClientIdentifierMutation = () => {
  const isPeriodicReview = useIsPeriodicReview();
  const liveMutation = useProfileNationalClientIdentifierMutation();
  const draftMutation = useProfilePeriodicReviewNationalClientIdentifierMutation();

  return isPeriodicReview ? draftMutation : liveMutation;
};
